import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';

import './Cotizar.scss';
import FormHeader from '../FormHeader/FormHeader';
import FormField from '../FormField';
import useCar from '../../utils/hooks/useCar';
import Button from '../Button';
import Recaptcha from '../Recaptcha/Recaptcha';
import { IsOnlyNumbers } from '../../utils/helpers';
import { useUserData } from '../../utils/hooks';
import { useHistory } from 'react-router';


const Cotizar = ({ logoUrl, car, isLoading, sendCotizacionRequest }) => {
  const { saveUserData, userData, getClientInfoRequest, gometa } = useUserData();
  const [hideId] = useState(false);
  const [passedCaptcha, setPassedCaptcha] = useState(false); 
  const { imageUrl } = useCar(car);
  const history = useHistory();

  const getClientInfo = (dat, setField) => {
    getClientInfoRequest(dat, ({ data }) => {
      if (!data || !data?.length) {
        return;
      }
      const d = data[0];
      if (d?.guess_type === 'DIMEX/NITE') {
        setField('name_client', d.firstname);
        setField('last_name', d.lastname);
        setField('type_id', 'DIMEX');
      } else if (d?.guess_type !== 'FISICA') {
        setField('name_client', d.fullname);
        setField('last_name', 'N/A');
        setField('type_id', 'JURIDICO');
      } else {
        setField('name_client', d.firstname);
        setField('last_name', d.lastname);
        setField('type_id', 'FISICO');
      }
    });
  }

  return (
    <div className="cotizar gradient gradient--full" style={{ '--color': car?.colorCode }}>
      <FormHeader
        isLoading={isLoading}
        car={car}
        logoUrl={logoUrl}
        sectionHeader="ingresár tus datos para comprar tu chuzo."
        headerText="Cotizar mi vehículo"
        headerSubText="Cotizá tu chuzo de manera fácil y segura…"
        bottomBorder
      />
      <div className="purchase__content classic-form">
        {/* <div className="purchase__aside">
          <div className="purchase__image">
            {!imageUrl ? (
              <Skeleton circle={true} height={200} width={200} />
            ) : (
              <img src={imageUrl} alt="Vehiculo" />
            )}
          </div>
          <h4 className="classic-form__mobile-header mobile">
            ENVIAR COTIZACIÓN POR CORREO
          </h4>
        </div> */}
        <div className="classic-form__form ">
        <Formik
            initialValues={{
              name_client: userData.name,
              last_name: userData.lastName,
              type_id: hideId ? "" : (userData.typeId || 'FISICO'),
              id_real: hideId ? "" : userData.id,
              email: userData.email,
              phone: userData.phone,
              direccion: userData.address,
              profesion: userData.profession,
              type: userData.typeContract,
              way_contact: userData.typeContact,
              sucursal_de_retiro: '',
              observations: '',
              politica: 'politica'
            }}
            validationSchema={Yup.object().shape({
              name_client: Yup.string().required('Requerido'),
              last_name: Yup.string().required('Requerido'),
              type_id: !hideId ? Yup.string().required('Requerido') : Yup.string(),
              id_real: Yup.number().integer().test('len', 'Ingrese un formato correcto con solo números', val => {
                if (hideId) {
                  return true;
                }
                const hasOnlyNumbers = IsOnlyNumbers(val);
                if (!hasOnlyNumbers) {
                  return false;
                }
                return !!val && (val).toString().length <= 12 && (val).toString().length > 8; }),
              email: Yup.string().required('Requerido').email('El email es inválido'),
              phone: Yup.number().integer().test('len', 'El télefono debe contener 8 digitos y solo números', val => {
                const hasOnlyNumbers = IsOnlyNumbers(val);
                if (!hasOnlyNumbers) {
                  return false;
                }
                return !!val && (val).toString().length === 8;
              }),
              // direccion: Yup.string(),
              // profesion: Yup.string().required('Requerido'),
              way_contact: Yup.string().required('Requerido'),
              sucursal_de_retiro: '',
              observations: Yup.string(),
              politica: Yup.string().required('Requerido'),
              // terminos: Yup.string().required('Requerido'),
            })}
            onSubmit={values => {
              saveUserData({ 
                email: values.email, 
                name: values.name_client, 
                phone: values.phone, 
                lastName: values.last_name, 
                typeId: values.type_id, 
                id: values.id_real, 
                profession: values.profesion, 
                address: values.direccion, 
                typeContract: values.type, 
                typeContact: values.way_contact
              })
              sendCotizacionRequest(values);
              history.push('gracias-por-cotizar/');
            }}
          >
            {formik => {
              return (
                <form onSubmit={formik.handleSubmit}>
                  <div className="classic-form__header">
                    <div className="classic-form__header-info">
                      <h4 className="classic-form__mobile-header classic-form__desktop-header desktop ">
                      ENVIAR COTIZACIÓN POR CORREO
                      </h4>
                      <h3 className="classic-form__subheader">Datos personales</h3>
                      {!hideId && <div className="form-field">
                        <label className="form-field__label">Para agilizar el proceso <strong>ingresá</strong> tu número de identificación.</label>
                      </div>}
                    </div>
                    <div className="classic-form__header-img purchase__image">
                      {!imageUrl ? (
                        <Skeleton circle={true} height={200} width={200} />
                      ) : (
                        <img src={imageUrl} alt="Vehiculo" />
                      )}
                    </div>
                  </div>
                  
                  <br/>
                  {!hideId && <div className="classic-form__row">
                    <div className="classic-form__field">
                      <FormField
                        label="Número de Identificación"
                        id="id_real"
                        name="id_real"
                        type="number"
                        placeholder="000000000"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.id_real}
                        touched={formik.touched.id_real}
                        error={formik.errors.id_real}
                        required
                        pattern="[0-9\]+"
                      />
                      {!gometa?.isLoading && <span className="waiting-message waiting-message--search">
                        <Button type="red" button="button" onClick={(e) => {
                          e.preventDefault();
                          if (formik?.errors?.id_real) {
                            return;
                          }
                          getClientInfo(formik?.values?.id_real, formik.setFieldValue);
                        }}>  
                          Buscar
                        </Button>
                      </span>}
                      {gometa?.isLoading && <span className="waiting-message"> Espera unos segundos y verifica tu información.</span>}
                    </div>
                  </div>}
                  <div className="classic-form__row">
                    <div className="classic-form__field">
                      <FormField
                        label="Nombre"
                        id="name_client"
                        name="name_client"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name_client}
                        touched={formik.touched.name_client}
                        error={formik.errors.name_client}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Apellidos"
                        id="last_name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.last_name}
                        touched={formik.touched.last_name}
                        error={formik.errors.last_name}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Correo electrónico"
                        id="email"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        touched={formik.touched.email}
                        error={formik.errors.email}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Número de teléfono"
                        id="phone"
                        name="phone"
                        type="number"
                        placeholder="88888888"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone}
                        touched={formik.touched.phone}
                        error={formik.errors.phone}
                        required
                        pattern="[0-9\]+"
                      />
                    </div>
                  </div>
                  {!hideId && <div className="classic-form__row">
                    <div className="classic-form__field" style={{ zIndex: 4 }}>
                      <FormField
                        label="Tipo de Identificación"
                        id="type_id"
                        name="type_id"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.type_id}
                        touched={formik.touched.type_id}
                        error={formik.errors.type_id}
                        required
                        options={[
                          { value: 'FISICO', label: 'Físico' },
                          { value: 'JURIDICO', label: 'Jurídico' },
                          { value: 'DIMEX', label: 'DIMEX' },
                          {
                            value: 'CUERPO DIPLOMATICO',
                            label: 'Cuerpo Diplomático',
                          },
                        ]}
                      />
                    </div>
                  </div>}
                  {/* <div className="classic-form__row"> */}
                    {/* <div className="classic-form__field">
                      <FormField
                        label="Profesión"
                        id="profesion"
                        name="profesion"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.profesion}
                        touched={formik.touched.profesion}
                        error={formik.errors.profesion}
                        required
                      />
                    </div> */}
                    {/* <div className="classic-form__field" />
                  </div> */}
                  {/* <div className="classic-form__row">
                    <div className="classic-form__field">
                      <FormField
                        label="Dirección"
                        id="direccion"
                        name="direccion"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.direccion}
                        touched={formik.touched.direccion}
                        error={formik.errors.direccion}
                      />
                    </div>
                  </div> */}
                  
                  <div className="classic-form__row" style={{position: 'relative'}}>
                    {/* <div className="classic-form__field">
                      <FormField
                        label="Tipo de contrato"
                        id="type"
                        name="type"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.type}
                        touched={formik.touched.type}
                        error={formik.errors.type}
                        required
                        options={[
                          { value: 'CONTADO', label: 'Contado' },
                          { value: 'CREDITO LARGO PLAZO', label: 'Crédito largo plazo' },
                        ]}
                      />
                    </div> */}
                    <div className="classic-form__field">
                      <FormField
                        label="Quiero que me contacten por"
                        id="way_contact"
                        name="way_contact"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.way_contact}
                        touched={formik.touched.way_contact}
                        error={formik.errors.way_contact}
                        required
                        options={[
                          { value: 'whatsapp', label: 'Whatsapp' },
                          { value: 'email', label: 'Correo electrónico' },
                          { value: 'call', label: 'Llamada' },
                        ]}
                      />
                    </div>
                    <div className="classic-form__field classic-form__field--half">
                      <FormField
                        label="Escribe alguna observación o detalle importante de tu cotización"
                        id="observations"
                        name="observations"
                        type="textarea"
                        placeholder="Escribe un comentario…"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.observations}
                        touched={formik.touched.observations}
                        error={formik.errors.observations}
                      />
                    </div>
                    <p className="classic-form__mandatory-legend">
                      * Campos obligatorios
                    </p>
                  </div>
                  <div className="classic-form__row">
                      <FormField
                        style={{ margin: "1.9rem 0" }}
                        url="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf"
                        label=""
                        id="politica"
                        name="politica"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.politica}
                        touched={formik.touched.politica}
                        error={formik.errors.politica}
                        options={[
                          {
                            component: (
                              <>
                                <div className="classic-form__field--anchor">
                                *<a target="_blank" href="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf">ACEPTO POLÍTICAS DE PRIVACIDAD</a> Y <a target="_blank" href="/wp-content/themes/veinsa/files/terminos_condiciones_veinsamotors.pdf">TÉRMINOS Y CONDICIONES</a>
                                </div>
                              </>
                            ),
                            value: 'politica',
                            label: 'Acepto Política de privacidad',
                          },
                        ]}
                      />
                      <div className="classic-form__row classic-form__row--send">
                        <Recaptcha
                          onChange={value => {
                            if (value) {
                              setPassedCaptcha(true);
                            }
                          }}
                        />
                        <Button submit disabled={!passedCaptcha || !formik.isValid || formik.isSubmitting} type="red">
                          Enviar solicitud
                        </Button>
                      </div>
                    </div>
                    {/* <div className="classic-form__field">
                      <FormField
                        url="/wp-content/themes/veinsa/files/terminos_condiciones_veinsamotors.pdf"
                        label=""
                        id="terminos"
                        name="terminos"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.terminos}
                        touched={formik.touched.terminos}
                        error={formik.errors.terminos}
                        options={[
                          {
                            value: 'terminos',
                            label: 'Términos y condiciones',
                          },
                        ]}
                      />
                    </div> */}                  
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Cotizar;
